import styled from '@emotion/styled';

import StatusCell from '../../Badge/StatusCell';
import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';

interface DriverPerformanceProfileViewProps {
  data?: Record<string, any>;
}

const DriverPerformanceProfileView: React.FC<
  DriverPerformanceProfileViewProps
> = ({ data }) => {
  return (
    <TableSliderContentWrapper label='Driver Profile'>
      <ImageArea>
        <Img src='/static/img/placeholderRider.png' />
        <Name>Dami Timilehin</Name>
        <div>Driver</div>
      </ImageArea>

      <Section>
        <Cell>
          <CellLabel>Current Employment Status</CellLabel>
          <StatusCell
            hasDot
            data={{ status: 'Exited' }}
            statusKey='status'
            customClasses='small-border-radius'
          />
        </Cell>
        <Cell>
          <CellLabel>End Date</CellLabel>
          <div>25 Dec 2025</div>
        </Cell>
        <Cell>
          <CellLabel>Reason for Resignation</CellLabel>
          <div>Termination</div>
        </Cell>
        <Cell>
          <CellLabel>Hiring Eligibility</CellLabel>
          <StatusCell
            data={{ status: 'Positive' }}
            statusKey='status'
            customClasses='small-border-radius'
          />
        </Cell>
        <Cell>
          <CellLabel>Total theft cases reported</CellLabel>
          <div>10</div>
        </Cell>
        <Cell>
          <CellLabel>Total accident cases reported</CellLabel>
          <div>3</div>
        </Cell>
        <Cell>
          <CellLabel>Final review </CellLabel>
          <blockquote
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
          >
            <p>
              "David was a reliable and professional driver throughout his
              contract period. He demonstrated excellent driving skills and
              maintained good relationships with clients."
            </p>
            <cite
              style={{
                fontSize: '12px',
                fontWeight: 400,
              }}
            >
              — Sarah Bradley Adams, Fleet Manager
            </cite>
          </blockquote>
        </Cell>
      </Section>
    </TableSliderContentWrapper>
  );
};

export default DriverPerformanceProfileView;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  color: #2f3644;
  background-color: rgba(250, 250, 250, 0.8);
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;

const ImageArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
  gap: 12px;
  padding-top: 20px;
  font-size: 14px;
  font-weight: 400;
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;
`;

const Name = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  text-align: center;
  color: #000000;
  margin-bottom: -6px;
`;
